import styled, { css } from 'styled-components';
import { alto, wildSand, white } from '../Colors/Colors';
const LightContextStyle = /*#__PURE__*/css(["background-color:", ";"], wildSand);
const GhostContextStyle = /*#__PURE__*/css(["background-color:", ";"], white);
const RecessedShadow = /*#__PURE__*/css(["display:block;content:'';position:absolute;left:0;width:100%;border-radius:100%;height:50px;color:", ";box-shadow:0 0 10px 3px;"], alto);
const RecessedContextStyle = /*#__PURE__*/css(["", ";position:relative;overflow:hidden;&:not(:first-child)::before{bottom:100%;", ";}&:not(:last-child)::after{top:100%;", ";}"], LightContextStyle, RecessedShadow, RecessedShadow);

const getContextStyle = context => {
  switch (context) {
    case 'ghost':
      return GhostContextStyle;

    case 'light':
      return LightContextStyle;

    case 'recessed':
      return RecessedContextStyle;
  }
};

const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1imjosf-0"
})(["position:relative;box-sizing:border-box;", " ", "  "], _ref => {
  let {
    withBorder
  } = _ref;
  return withBorder && css(["border:1px solid ", ";& + ", "{border-top:none;}"], alto, Container);
}, _ref2 => {
  let {
    context
  } = _ref2;
  return context && getContextStyle(context);
});
export default Container;